import curry from "../lib/core/functional/curry";

import { sendJsonRequest } from "./utils";

const sendRequest = curry(sendJsonRequest);

export const signupRequest = sendRequest("/core/setup/signup/v2", "POST");

export function verifyOtp(body) {
    return sendJsonRequest("/core/v1/users/me/auth/otps/verify", "POST", body);
}

export function loginRequest(body, queryString) {
    return sendJsonRequest(`/core/users/email_login_json/${queryString || ""}`, "POST", body);
}

export const resetPasswordRequest = sendRequest("/core/users/password_reset/", "POST");
